import { Select, Form } from "antd"
import { useState, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { buildGlobalMasterLabelMap, buildMasterOptionLabelMap, getLocalizedMasterCellText, getUniqueValuesFromArray, isUuidLike, resolveMasterValueLabel } from "../../../utils/masterHelper"

const ParentSelector = (props) => {
    const { label, placeholder, originalLabel, disabled, masterList, name, help, rules, masterData, formValues, multiSelect=false } = props
    const { i18n } = useTranslation()
    // Options display in the reader's language while their stored values stay canonical
    const contentLang = props.contentLang || i18n.language
    const [options, setOptions] = useState([])
    let parentColumnLabel = props.mappedColumn
    // Values coming from the parent table can be option ids of that table's own dropdown column
    const labelMap = useMemo(
        () => buildMasterOptionLabelMap({ options: props.options, parentTable: props.parentTable, mappedColumn: parentColumnLabel }, masterList, contentLang),
        [props.options, props.parentTable, parentColumnLabel, masterList, contentLang]
    )
    const globalLabelMap = useMemo(() => buildGlobalMasterLabelMap(masterList, contentLang), [masterList, contentLang])
    const resolveLabel = (value) => resolveMasterValueLabel(value, labelMap, globalLabelMap)
    // Text columns carry their translation on the row; id columns are relabelled
    // through the maps. Prefer that over the snapshot option label.
    const resolveRowLabel = (row, sourceTable, rawValue, fallbackLabel) => {
        const column = parentColumnLabel || originalLabel
        const columnField = sourceTable?.fields?.find((field) => field?.label === column)
        const localized = getLocalizedMasterCellText(row, column, columnField, sourceTable, masterList, contentLang)
        if (localized !== undefined && localized !== null && localized !== "" && !isUuidLike(String(localized))) {
            return localized
        }
        return resolveLabel(fallbackLabel ?? rawValue)
    }
    let dataArr = masterList.find(master => master?.fields?.find(field => field.label === parentColumnLabel && master.dataId === props.parentTable));

    const getDefaultOptions = () => {
        if(props.parentTable){
            let parentTableData = masterList.find(list => list.dataId === props.parentTable)
            
            let reqDataArr = parentTableData?.data?.filter(data => data[parentColumnLabel])
            let uniqueArr = getUniqueValuesFromArray(reqDataArr, parentColumnLabel)
            uniqueArr = uniqueArr.map(data => {
                const rawValue = data[parentColumnLabel]
                return {label: resolveRowLabel(data, parentTableData, rawValue), value: rawValue}
            })

            setOptions(uniqueArr)
        } else {
            if(dataArr) {
                let fieldData = dataArr?.data || [];
                fieldData = fieldData.map(data => {
                    const rawValue = data[parentColumnLabel] ?? data[originalLabel]
                    const matchedOption = props?.options?.find(opt => opt?.value === data?.uuid || opt?.value === rawValue)
                    const mappedValue = resolveRowLabel(data, dataArr, rawValue, matchedOption?.label)
                    return {label: mappedValue, value: matchedOption?.value ?? rawValue}
                })
                setOptions(fieldData)
            } else {
                  let fieldData = props?.options?.map(data => {
                    const optionValue = data?.value || data?.label || data
                    return {label: resolveLabel(data?.label || data), value: optionValue}
                })
                setOptions(fieldData)
            }
        }
    }

    const getFilteredRowsBySiblingSelections = (sourceRows = []) => {
        if (!masterData?.fields || !formValues) {
            return sourceRows
        }

        const siblingFields = masterData.fields.filter(field =>
            field?.formType === "dropdownField" &&
            field?.parentTable === props.parentTable &&
            field?.label !== name &&
            formValues[field.label] !== undefined &&
            formValues[field.label] !== null &&
            formValues[field.label] !== ""
        )

        if (!siblingFields.length) {
            return sourceRows
        }

        return sourceRows.filter(row => siblingFields.every(field => row?.[field.mappedColumn] === formValues[field.label]))
    }

    useEffect(() => {
        getDefaultOptions()
    }, [masterList, contentLang, props.parentTable, parentColumnLabel])


    useEffect(() => {
        if(formValues) {
            let parentTableData = masterList.find(list => list.dataId === props.parentTable)

            if(parentTableData?.data?.length){
                let filteredDataArr = getFilteredRowsBySiblingSelections(parentTableData.data)
                filteredDataArr = getUniqueValuesFromArray(filteredDataArr, parentColumnLabel)
                filteredDataArr = filteredDataArr.map(data => {
                    const rawValue = data[parentColumnLabel] ?? data[originalLabel]
                    const matchedOption = props?.options?.find(opt => opt?.value === data?.uuid || opt?.value === rawValue)
                    const mappedValue = resolveRowLabel(data, parentTableData, rawValue, matchedOption?.label)
                    return {label: mappedValue, value: matchedOption?.value || rawValue}
                })

                if (filteredDataArr.length) {
                    setOptions(filteredDataArr)
                } else {
                    getDefaultOptions();
                }
            } else {
                getDefaultOptions();
            }

        }
    }, [formValues, masterList, contentLang, props.parentTable, parentColumnLabel])


    const handleChange = (value) => {
    }

    return (
        <Form.Item label={label} name={name} tooltip={help} rules={rules}>
            <Select
                placeholder={placeholder}
                disabled={disabled}
                options={options}
                mode={multiSelect ? "multiple" : undefined}
                allowClear
                showSearch
                onChange={handleChange}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
            />
        </Form.Item>
    )

}

export default ParentSelector
